module.exports = __webpack_public_path__ + "img/serve_page_two_side_bg.02a924d4.png";